import { appHistory } from '@core/Utils/routing/history'

export const isHome = () => isHomeUrl(window.location.pathname)

export function navChange(url: string) {
  appHistory.push(getPathname(url))
}

export function getPathname(url?: string) {
  url = url || window.location.pathname
  return url.replace(/^\/*#?\/*(.*)$/, '/$1')
}

export function isHomeUrl(url: string): boolean {
  return url === '' || url === '/' || url.search('^[?].*$') > -1
}
